export default "__VITE_ASSET__b324b2b2__"